import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white">
            <div className="w-16 h-16 border-4 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin mb-4"></div>
            <p className="text-indigo-400 font-medium animate-pulse">Loading Fiscoe...</p>
        </div>
    );
};

export default LoadingSpinner;
